import { useLogin } from '@ixigo-packages/login';
import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { FC, useCallback } from 'react';
import { Event } from '../../enums/event';
import loggedOut from '../../images/loggedOut.svg';
import { recordEvent } from '../../utils/analytics';
import { isMobile } from '../../utils/common';
import { getCookieHelpers } from '../../utils/cookie';

const LoggedOut: FC = () => {
    const { triggerLogin } = useLogin();
    const isMob = isMobile();

    const loginRedirect = useCallback(() => {
        recordEvent(Event.HC_LOGIN_REDIRECT, {});
        triggerLogin(() => {
            getCookieHelpers().syncCookies();
            window.location.reload();
        });
    }, [triggerLogin]);

    return (
        <div
            className={clsx(
                'flex flex-col p-20',
                isMob ? 'gap-10 bg-white' : 'gap-20 justify-center items-center h-fit rounded-20 shadow-100',
            )}
        >
            {!isMob && <img src={loggedOut} width={160} height={160} alt='Log in' loading='lazy' />}
            <Typography variant={isMob ? 'h4' : 'h5'} fontWeight='medium' className={clsx(!isMob && 'text-center')}>
                Need help with your recent booking?
            </Typography>
            <Button variant='solid' size='lg' className={clsx(isMob ? 'w-fit' : 'w-full')} onClick={loginRedirect}>
                Log in Now
            </Button>
        </div>
    );
};

export default LoggedOut;
